<template>
  <div class="container">
    <img @click="viewBigPic(bigPic)" class="bigImage" :src="bigPic" />
    <div class="titleBg">
      <span class="companyItem_text1">{{companyName}}</span>
      <span class="companyItem_text2">{{address}}</span>
    </div>
    <section class="mess_box" v-if="companyWallMess.phone || companyWallMess.networkAddress">
      <p @click="callPhone" v-if="companyWallMess.phone">联系电话：{{companyWallMess.phone}}</p>
      <p class="btn_duplicate" v-if="companyWallMess.networkAddress" @click="copyTradeCode" :data-clipboard-text="companyWallMess.networkAddress">企业官网：{{companyWallMess.networkAddress}}</p>
    </section>
    <div class="viewhtml" v-html="html"></div>
    <img v-if="logo" class="logo border" :src="logo" />
    <img v-else class="logo" src="../../assets/images/img_company_wall.jpg" />

    <fade-animation>
      <common-gallary :imgs="imgsArr" v-show="showGallary" @close="handleGallaryClose"></common-gallary>
    </fade-animation>
  </div>
</template>
<script>
import { getCompanyWallByMallIdAndCompanyId } from "../../utils/api";
import util from "../../utils/util";
import { mapState } from "vuex";
import CommonGallary from "../../components/Gallary";
import FadeAnimation from "../../components/FadeAnimation";
import Clipboard from 'clipboard';
import wx from 'weixin-js-sdk';
//import wx from 'jweixin-1.6.0'
export default {
  name: "companyDetail",
  components: {
    CommonGallary,
    FadeAnimation
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  filters: {
    time(val) {
      return util.formatTime(new Date(val), 6);
    }
  },
  data() {
    return {
      tabs: ["活动", "企业墙"],
      activeTab: 1,
      dataList: [],
      id: "",
      html: "",
      companyName: "",
      logo: "",
      address: "",
      bigPic: "",
      imgsArr: [],
      companyWallMess:{},
      showGallary: false
    };
  },
  created() {
    let query = this.$route.params;
    this.id = query.id;
    this.getCompanyWallByMallIdAndCompanyId();
  },
  methods: {
    copyTradeCode () {
      var clipboard = new Clipboard('.btn_duplicate')
      clipboard.on('success', () => {
        util.showToast('复制成功')
          // 释放内存
        clipboard.destroy()
      })
    },
    viewBigPic(pic) {
      this.imgsArr = [];
      this.imgsArr.push(pic);
      this.showGallary = true;
    },
    handleGallaryClose() {
      this.showGallary = false;
    },
    callPhone(){
      location.href = 'tel:'+this.companyWallMess.phone
    },
    getCompanyWallByMallIdAndCompanyId() {
      let params = {
        mallId: this.common.marketInfo.id,
        companyId: this.id
      };
      let that = this;
      getCompanyWallByMallIdAndCompanyId(params, {
        cityId: this.common.marketInfo.cityId,
        userId: this.common.userId
      }).then(res => {
        console.log(res);
        if (res.res.code === 10000) {
          var item = res.body.companyWallLogo;
          this.companyWallMess = item;
          this.companyName = item.companyName;
          this.logo = item.logo;
          this.address = item.address;
          this.bigPic = item.bigPic;
          this.html = item.companyDetail;
          // 首页分享
          let address = window.location.href.split('?')[0];
          wx.ready(()=>{
            let obj = {
              title: that.companyName, // 分享标题
              desc: '地址:'+that.address,
              link: address+'?marketId='+that.common.marketInfo.id+'&cityId='+that.common.cityId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.logo,// 分享图标
              success:function(){
                util.showToast('已分享')
              }
            }
            wx.onMenuShareAppMessage(obj)
            wx.onMenuShareTimeline(obj)
          })
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  min-height: 100vh;
  .flex(column);
}
.bigImage {
  width: 100%;
  height: 500px;
  background: rgba(235, 235, 235, 1);
  display: flex;
}
.titleBg {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  padding-bottom: 40px;
  border-bottom: 14px solid #f3f4f6;
}

.companyItem_text1 {
  display: block;
  margin: 108px auto 0;
  width: 80%;
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
}

.companyItem_text2 {
  display: block;
  margin: 14px auto 0;
  width: 80%;
  text-align: center;
  font-size: 28px;
  color: rgba(153, 153, 153, 1);
  line-height: 40px;
}

.logo {
  width: 160px;
  height: 160px;
  position: absolute;
  object-fit: contain;
  background:#fff;
  left: 50%;
  top: 420px;
  transform: translateX(-50%);
  border-radius: 8px;
  box-shadow:0 0 10px 1px rgba(0,0,0,0.1);
}
.mess_box{
  padding:0 28px;
  background:#fff;
  border-bottom:14px solid #f3f4f6;
  p{
    line-height: 40px;
    padding:30px 0;
    font-size:28px;
    color:#333;
    .borderB();
    word-break:break-all;
    &:last-child{
      border:0;
    }
  }
}
.viewhtml {
  padding: 40px 28px;
  /deep/ strong {
    font-weight: bold;
    .fontSize(15px);
    line-height: 50px;
  }
  /deep/ p {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ span {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ img {
    max-width: 100%;
    min-width: 40%;
    margin: 10px auto;
    height: auto;
    display: block;
  }
  /deep/ figcaption {
    text-align: center;
    .fontSize(14px);
    line-height: 50px;
  }
  /deep/ tr,
  td,
  th {
    .fontSize(14px);
  }
}
</style>
